import * as React from "react";
const SvgCalendarDay = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M11 0h2v2h2v13H1V2h2V0h2v2h6zm2 13V9H9v4z", clipRule: "evenodd" }));
export default SvgCalendarDay;
